import { render, staticRenderFns } from "./TeacherProfile.vue?vue&type=template&id=1831fc1c&scoped=true&"
import script from "./TeacherProfile.vue?vue&type=script&lang=js&"
export * from "./TeacherProfile.vue?vue&type=script&lang=js&"
import style0 from "./TeacherProfile.vue?vue&type=style&index=0&id=1831fc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1831fc1c",
  null
  
)

export default component.exports